document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector(".facets");
  if (!form) return;

  form.addEventListener("change", function () {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    // Preserve sort_by from current URL if present and not in form
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has('sort_by') && !searchParams.has('sort_by')) {
      searchParams.set('sort_by', currentUrl.searchParams.get('sort_by'));
    }

    fetch(window.location.pathname + "?" + searchParams.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const active_filters = doc.querySelector('.active-filters');
        const newProducts = doc.querySelector('[data-products]');
        const newFilters = doc.querySelector('.facets');
        const CollectionPagination = doc.querySelector('.CollectionPagination');

        if (newProducts !== null) {
          document.querySelector('[data-products]').innerHTML = newProducts.innerHTML;
                    const oldLoadMore = document.querySelector('.LoadMoreWrapper');
const newLoadMore = doc.querySelector('.LoadMoreWrapper');

if (oldLoadMore) {
  oldLoadMore.remove();
}

if (newLoadMore) {
  document
    .querySelector('.ProductListWrapper')
    .insertAdjacentHTML('afterend', newLoadMore.outerHTML);
}
        } else {
          document.querySelector('[data-products]').innerHTML = '<div class="no-results">No products found</div>';
        }
        
        document.querySelector('.facets').innerHTML = newFilters.innerHTML;
        document.querySelector('.active-filters').innerHTML = active_filters.innerHTML;
        document.querySelector('.CollectionPagination').innerHTML = CollectionPagination.innerHTML;

        // Add is-active class to the current page link
        const activePageLink = document.querySelector(`.Pagination__NavItem[data-paginate="1"]`);
        if (activePageLink) {
          activePageLink.classList.add('is-active');
        }

        history.pushState({}, '', window.location.pathname + '?' + searchParams);
      });
  });

  
  document.addEventListener("click", function (e) {

    // Event delegation for remove-filter clicks
    const target = e.target.closest(".active-filters .remove-filter:not(.remove-filter--clear)");
    if (target) {
      e.preventDefault();
      const filter_url = target.getAttribute("href");

      fetch(filter_url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const active_filters = doc.querySelector('.active-filters');
          const newProducts = doc.querySelector('[data-products]');
          const newFilters = doc.querySelector('.facets');
          const CollectionPagination = doc.querySelector('.CollectionPagination');

          if (newProducts !== null) {
            document.querySelector('[data-products]').innerHTML = newProducts.innerHTML;
                      const oldLoadMore = document.querySelector('.LoadMoreWrapper');
const newLoadMore = doc.querySelector('.LoadMoreWrapper');

if (oldLoadMore) {
  oldLoadMore.remove();
}

if (newLoadMore) {
  document
    .querySelector('.ProductListWrapper')
    .insertAdjacentHTML('afterend', newLoadMore.outerHTML);
}
          } else {
            document.querySelector('[data-products]').innerHTML = '<div class="no-results">No products found</div>';
          }

          document.querySelector('.facets').innerHTML = newFilters.innerHTML;
          document.querySelector('.active-filters').innerHTML = active_filters.innerHTML;
          document.querySelector('.CollectionPagination').innerHTML = CollectionPagination.innerHTML;

          // Add is-active class to the current page link
          const activePageLink = document.querySelector(`.Pagination__NavItem[data-paginate="1"]`);
          if (activePageLink) {
            activePageLink.classList.add('is-active');
          }

          history.pushState({}, '', filter_url);
        });
    }

    // Event delegation for sort-by popover
    const sortBtn = e.target.closest('#collection-sort-popover [data-action="select-value"]');
    if (sortBtn) {
      e.preventDefault();
      const sortValue = sortBtn.getAttribute('data-value');

      var pageNum = 1;

      // Get current search params, update sort_by
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);

      // Preserve sort_by from current URL if present and not in form
      if (url.searchParams.has('paginate')) {
        url.searchParams.set('paginate', url.searchParams.get('paginate'));
        pageNum = url.searchParams.get('paginate');
      }

      fetch(url.pathname + '?' + url.searchParams.toString())
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const active_filters = doc.querySelector('.active-filters');
          const newProducts = doc.querySelector('[data-products]');
          const newFilters = doc.querySelector('.facets');
          const CollectionPagination = doc.querySelector('.CollectionPagination');

          if (newProducts !== null) {
            document.querySelector('[data-products]').innerHTML = newProducts.innerHTML;
                      const oldLoadMore = document.querySelector('.LoadMoreWrapper');
const newLoadMore = doc.querySelector('.LoadMoreWrapper');

if (oldLoadMore) {
  oldLoadMore.remove();
}

if (newLoadMore) {
  document
    .querySelector('.ProductListWrapper')
    .insertAdjacentHTML('afterend', newLoadMore.outerHTML);
}
          } else {
            document.querySelector('[data-products]').innerHTML = '<div class="no-results">No products found</div>';
          }
          
          document.querySelector('.facets').innerHTML = newFilters.innerHTML;
          document.querySelector('.active-filters').innerHTML = active_filters.innerHTML;
          document.querySelector('.CollectionPagination').innerHTML = CollectionPagination.innerHTML;

          // Add is-active class to the current page link
          const activePageLink = document.querySelector(`.Pagination__NavItem[data-paginate="${pageNum}"]`);
          if (activePageLink) {
            activePageLink.classList.add('is-active');
          }

          history.pushState({}, '', url.pathname + '?' + url.searchParams.toString());
        });
    }

    // Event delegation for AJAX pagination
    const pageLink = e.target.closest('.Pagination__NavItem');
    if (pageLink) {
      e.preventDefault();
      const pageNum = pageLink.getAttribute('data-paginate');
      const urlObj = new URL(window.location.href);

      // Remove any existing paginate param
      urlObj.searchParams.delete('paginate');
      // Add the new paginate param
      urlObj.searchParams.set('paginate', pageNum);

      const url = urlObj.pathname + '?' + urlObj.searchParams.toString();

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const active_filters = doc.querySelector('.active-filters');
          const newProducts = doc.querySelector('[data-products]');
          const newFilters = doc.querySelector('.facets');
          const CollectionPagination = doc.querySelector('.CollectionPagination');

          if (newProducts !== null) {
            document.querySelector('[data-products]').innerHTML = newProducts.innerHTML;
                      const oldLoadMore = document.querySelector('.LoadMoreWrapper');
const newLoadMore = doc.querySelector('.LoadMoreWrapper');

if (oldLoadMore) {
  oldLoadMore.remove();
}

if (newLoadMore) {
  document
    .querySelector('.ProductListWrapper')
    .insertAdjacentHTML('afterend', newLoadMore.outerHTML);
}
          } else {
            document.querySelector('[data-products]').innerHTML = '<div class="no-results">No products found</div>';
          }

          document.querySelector('.facets').innerHTML = newFilters.innerHTML;
          document.querySelector('.active-filters').innerHTML = active_filters.innerHTML;
          document.querySelector('.CollectionPagination').innerHTML = CollectionPagination.innerHTML;

          // Add is-active class to the current page link
          const activePageLink = document.querySelector(`.Pagination__NavItem[data-paginate="${pageNum}"]`);
          if (activePageLink) {
            activePageLink.classList.add('is-active');
          }

          history.pushState({}, '', url);
        });
    }
  });


});